import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";

const ProcessContext = createContext(null);

export const useProcess = () => useContext(ProcessContext);

const AUTO_REMOVE_DELAY = 2000; // ms

const ProcessProvider = ({ children }) => {
  const [processes, setProcesses] = useState([]);
  const [visible, setVisible] = useState(true);

  const addProcess = useCallback((process) => {
    setProcesses((prev) => [
      ...prev,
      {
        ...process,
        percent: process.percent ?? 0,
        status: process.status ?? "active",
        steps: process.steps ?? [],
      },
    ]);
    setVisible(true);
  }, []);

  const updateProcess = useCallback((id, updates) => {
    setProcesses((prev) =>
      prev.map((p) => (p.id === id ? { ...p, ...updates } : p)),
    );
  }, []);

  const removeProcess = useCallback((id) => {
    setProcesses((prev) => prev.filter((p) => p.id !== id));
  }, []);

  /* 🔥 AUTO CLEAN PROSES SELESAI */
  useEffect(() => {
    const completed = processes.filter((p) => p.status !== "active");

    if (completed.length === 0) return;

    const timers = completed.map((p) =>
      setTimeout(() => {
        removeProcess(p.id);
      }, AUTO_REMOVE_DELAY),
    );

    return () => timers.forEach(clearTimeout);
  }, [processes, removeProcess]);

  /* 🔥 AUTO CLOSE PANEL */
  useEffect(() => {
    const hasActive = processes.some((p) => p.status === "active");
    if (!hasActive) {
      setVisible(false);
    }
  }, [processes]);

  const closePanel = () => setVisible(false);
  const openPanel = () => setVisible(true);

  return (
    <ProcessContext.Provider
      value={{
        processes,
        visible,
        addProcess,
        updateProcess,
        removeProcess,
        closePanel,
        openPanel,
      }}
    >
      {children}
    </ProcessContext.Provider>
  );
};

export default ProcessProvider;
